module.exports = __webpack_public_path__ + "static/img/avatar-logo.f831525e.png";